<template>
    <v-container fluid>
      <v-card>
        <v-toolbar dense flat color="secondary">
          <v-toolbar-title>Sales vs Stock</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row dense class="subtitle-2 text--primary">
            <v-col cols="12" xs="12" md="3">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    outlined
                    single-line
                    v-model="date"
                    label="From"
                    prepend-icon="mdi-calendar-month"
                    v-on="on"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker @change="getRecords" v-model="date" @input="menu1 = false"></v-date-picker>
              </v-menu>
  
              <span>Total Sales: {{ totalDailySales.toLocaleString() }}</span>
            </v-col>
  
            <v-col cols="12">
              <v-text-field name="Search" v-model="search" label="Search" dense></v-text-field>
              <!-- start of table -->
              <v-data-table
                :mobile-breakpoint="0"
                :items-per-page="pageItems"
                :headers="headers"
                :items="soldProducts"
                :search="search"
              >
                <!-- template -->
                <template v-slot:item.document.ocrd.Name="{ item }">
                  <span>{{ item.document.ocrd.Name }}</span>
                </template>
                <!-- end -->
                <!-- template -->
                <template v-slot:item.Price="{ item }">
                  {{
                  item.Price.toLocaleString()
                  }}
                </template>
                <!-- end -->
  
                <!-- template -->
                <template v-slot:item.priceDiff="{ item }">
                  {{
                  (item.Price - item.currentPrice).toLocaleString()
                  }}
                </template>
                <!-- end -->
  
                <!-- action template -->
                <template v-slot:item.document.DocNum="{ item }">
                  <v-btn
                    color="primary"
                    text
                    :to="`/pos/sale-details/${item.document.id}`"
                  >{{ item.document.DocNum }}</v-btn>
                </template>
                <!-- end -->
  
                <!-- template -->
                <template v-slot:item.LineTotal="{ item }">
                  {{
                  item.LineTotal.toLocaleString()
                  }}
                </template>
                <!-- end -->
              </v-data-table>
              <!-- end -->
            </v-col>
          </v-row>
  
          <!-- snackbar -->
          <snackbar ref="snackbar"></snackbar>
        </v-card-text>
      </v-card>
    </v-container>
  </template>
  
  <script>
  export default {
    data() {
      return {
        search: null,
        record: {},
        loader: false,
        summaryDialog: false,
        totalDailySales: 0,
        pageItems: 2000,
        date: new Date().toISOString().substr(0, 10),
        menu1: false,
        menu2: false,
        menu3: false,
        owner: null,
        owners: [],
        summaryData: [],
        outsourcedData: [],
        headers: [
          { text: "Product", value: "Name" },
          { text: "Total Sold", value: "TotalQty" },
          { text: "Remaining Qty", value: "RemainingQty" },
          { text: "Total Sales", value: "TotalSales" },
        ],
        summaryHeaders: [
          { text: "Item Name", value: "product" },
          { text: "Opening Stock", value: "openingQty" },
          { text: "Total Purchase", value: "totalBought" },
          { text: "Transfer In", value: "transIn" },
          { text: "Total Sold", value: "totalSold" },
          { text: "Transfer Out", value: "transOut" },
          { text: "Closing Stock", value: "closingQty" }
        ],
        outsourcedHeaders: [
          { text: "Item Name", value: "Name" },
          { text: "Quantity", value: "Quantity" },
          { text: "SellingPrice", value: "SellingPrice" },
          { text: "Total", value: "LineTotal" },
          { text: "Date", value: "DocDate" }
        ],
        fields: {
          product: "product",
          openingQty: "openingQty",
          totalGiven: "transIn",
          totalSold: "totalSold",
          closingQty: "closingQty"
        },
        returnHeaders: [
          { text: "Doc Num", value: "id" },
          { text: "Customer", value: "ocrd" },
          { text: "Product", value: "product" },
          { text: "Qty", value: "Quantity" },
          { text: "Price", value: "Price" },
          { text: "Total", value: "LineTotal" },
          { text: "User", value: "User" }
        ],
        soldProducts: [],
        totalSales: null,
        returnsData: [],
        TotalReturns: null
      };
    },
    computed: {
      totalSalesValue() {
        let total = 0;
        if (this.totalSales) {
          total = this.totalSales.toLocaleString();
        }
        return total;
      },
      storeName() {
        return localStorage.getItem("storeName");
      }
    },
    methods: {
      setDate(date) {
        this.date = date;
      },
      getRecords() {
        const self = this;
        const DocDate = this.date;
        const data = {
          StartDate: DocDate,
          SoldBy: null,
          ProductID: null,
          CustomerID: null,
          combinedReport: "N",
          owner: self.owner
        };
        
        this.$store.commit("loader", true);
        const url = `/sales-vs-stock`;
        this.$store
          .dispatch("post", { url, data })
          .then(res => {
            if (res.ResultCode == 1200) {
              self.soldProducts = res.ResponseData.soldProducts;
              self.totalDailySales = res.ResponseData.totalSales;
              self.$store.commit("loader", false);
            } else {
              this.$refs.snackbar.show(res.msg, "red");
              self.$store.commit("loader", false);
            }
          })
          .catch(err => {
            this.$refs.snackbar.show(err, "red");
          });
      },
      returnedProducts() {
        const data = {
          StartDate: new Date().toISOString().substr(0, 10),
          EndDate: new Date().toISOString().substr(0, 10),
          CustomerID: null
        };
        const self = this;
        const url = `/returned-products-report`;
        this.$store
          .dispatch("post", { url, data })
          .then(res => {
            if (res.ResultCode == 1200) {
              self.returnsData = res.ResponseData.AllSales;
              self.TotalReturns = res.ResponseData.TotalReturns;
            } else {
              this.$refs.snackbar.show(res.msg, "red");
            }
          })
          .catch(err => {
            this.$refs.snackbar.show(err, "red");
          });
      },
      getOwners() {
        const self = this;
        this.$store
          .dispatch("get", `/get-owner-users`)
          .then(res => {
            console.log(res.ResponseData);
            self.owners = res.ResponseData;
          })
          .catch(err => {
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    created() {
      this.getOwners();
      this.getRecords();
      this.returnedProducts();
    }
  };
  </script>
  
  <style lang="scss" scoped>
  </style>